import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import SearchEmptyStateImage from 'public/assets/images/searchEmptyState.svg';
export function SearchEmptyState() {
    const { t } = useTranslation();
    return (_jsxs("section", { className: "mx-4 my-6 flex flex-col items-center", children: [_jsx("img", { src: SearchEmptyStateImage, alt: "", className: "mb-5" }), _jsx("h2", { className: "mb-2 text-center text-extralarge text-neutral-900", children: t('content_list.search_empty_state.title') }), _jsx("p", { className: "mb-5 max-w-[600px] text-center text-small text-neutral-700", children: t('content_list.search_empty_state.subtitle') })] }));
}
